/* **********************************************************************************************************
 **** showPageBtnClickService : service written perofrm the click operation of buttons in showpage **********
 ***********************************************************************************************************/
(function(){
angular.module('ui2.0Service')       
    .factory('showPageBtnClickService', ['$rootScope', '$location', 'urlFactory','formService','entityFactory','dataManipulationService','showPageBulkActionService','delegationService','showPageService','$http',
        function ($rootScope, $location, urlFactory,formService,entityFactory,$dataManipulationService,showPageBulkActionService,delegationService, $showPageService,$http) {
    var commentForm = "comment";
    function fetchCommentFiles (dataObj) {
            dataObj.commentDocuments = {};
            dataObj.commentDocuments.values = [];
            var searchable, computation, key, name, financial, legal, businessCase, permissionArr,
                filesList = angular.element('.jx-fileListDiv').find('.jx-fileListSpan');
            for (let i = 0; i < filesList.length; i++) {
                financial = false;
                legal = false;
                businessCase = false;
                permissionArr = $(filesList[i]).find("select").val();
                searchable = $(filesList[i]).find("input.searchable").is(":checked");
                computation = $(filesList[i]).find("input.performanceData").is(":checked");
                key = $(filesList[i]).attr('file');
                name = $(filesList[i]).data("elemname");
                if (name != "documentFileData") {
                    dataObj[name] = {};
                    dataObj[name].name = name;
                    dataObj[name].values = [];
                    dataObj[name].values = {
                        "key": key
                    };
                }
                if (permissionArr != null) {
                    if (permissionArr.indexOf("12057") > -1) {
                        financial = true;
                    }
                    if (permissionArr.indexOf("12058") > -1) {
                        legal = true;
                    }
                    if (permissionArr.indexOf("12059") > -1) {
                        businessCase = true;
                    }
                }
                dataObj.commentDocuments.values.push({
                    "key": key,
                    "performanceData": computation,
                    "searchable": searchable,
                    "legal": legal,
                    "financial": financial,
                    "businessCase": businessCase
                });
            }
        };

    // function basicConfirmation(field, gFieldModel) {
    //     if (angular.isDefined(field.properties["onClick"]["successOnBoth"]) && (field.properties["onClick"]["successOnBoth"])) {
    //         if (angular.isDefined(field.properties["onClick"]["success"]) && (field.properties["onClick"]["success"].toString().trim().length > 0)) {
    //             $rootScope.parametersForNextDialog = {
    //                 "field": field,
    //                 "yesCB": 'successOnBothTrue',
    //                 "noCB": 'successOnBothFalse'
    //             };
    //             if (field.confirmationForBlockedEntities) {
    //                 this.confirmAlertDialog(intl_musg[6441], field.properties["onClick"]["title"], 'nextNotification', 'cancel', JSON.stringify(field));
    //             } else {
    //                 this.confirmAlertDialog(field.properties["onClick"]["message"], field.properties["onClick"]["title"], 'successOnBothTrue', 'successOnBothFalse', JSON.stringify(field));
    //
    //             }
    //
    //         } else {
    //             //              console.log("no further action is defined on confirmation.");
    //         }
    //     } else if (angular.isDefined(field.properties["onClick"]["success"]) && (field.properties["onClick"]["success"].toString().trim().length > 0)) {
    //         this.confirmAlertDialog(field.properties["onClick"]["message"], field.properties["onClick"]["title"], 'cnfTrue', 'cnfFalse', JSON.stringify(field));
    //     } else {
    //         field.openCommentDialogVar = {
    //             "temp": 'commentBox' + gFieldModel.replace(/\./g, "_"),
    //             "modal": commentForm
    //         }
    //         this.confirmAlertDialog(field.properties["onClick"]["message"], field.properties["onClick"]["title"], 'basicCnfTrue', 'basicCnfFalse', JSON.stringify(field));
    //     }
    //
    //
    // }

    function deleteConfirmation(field, gFieldModel) {
        field.openCommentDialogVar = {
            "temp": 'commentBox' + gFieldModel.replace(/\./g, "_"),
            "modal": commentForm
        }
        const args = {
            popupType: 'confirm',
            str: field.properties["onClick"]["message"] + SirionUtils.getCaptcha(field.properties),
            heading: field.properties["onClick"]["title"],
            yesCbFn: 'deleteCnfTrue',
            noCbFn: 'deleteCnfFalse',
            field: JSON.stringify(field)
        }
        SirionUtils.openSirionDialogs(args);
        // this.confirmAlertDialog(field.properties["onClick"]["message"] + SirionUtils.getCaptcha(field.properties), field.properties["onClick"]["title"], 'deleteCnfTrue', 'deleteCnfFalse', JSON.stringify(field));
    }

    function directNonAjax(field) {
        sessionStorage.removeItem('wf_id');
        delete $rootScope.createForWorkflowId;
        if (this.isCdrCreateExternalContactFlow && this.isCdrCreateExternalContactFlow()) {
            this.handleCdrCreateExternalContactCancel();
            return;
        }
        let url = urlFactory.convertUrlfromAPI(field.api, false)+'',
            searchParam = {};
        if(this.isNewUX) {
            SirionUtils.storePreviousPageURL();
        }
        $location.path(url).search(searchParam);
        if (!this.$$phase) {
            this.$apply();
        }
    }
    function basicConfirmation(field,gFieldModel){
        if (angular.isDefined(field.properties["onClick"]["successOnBoth"]) && (field.properties["onClick"]["successOnBoth"])) {
            if (angular.isDefined(field.properties["onClick"]["success"]) && (field.properties["onClick"]["success"].toString().trim().length > 0)) {
                $rootScope.parametersForNextDialog = {
                    "field": field,
                    "yesCB": 'successOnBothTrue',
                    "noCB": 'successOnBothFalse'
                };
                if (field.confirmationForBlockedEntities) {
                    const args = {
                        popupType: 'confirm',
                        str: intl_msg[6441],
                        heading: field.properties["onClick"]["title"],
                        yesCbFn: 'nextNotification',
                        noCbFn: 'cancel',
                        field: JSON.stringify(field)
                    }
                    SirionUtils.openSirionDialogs(args);
                } else {
                    const args = {
                        popupType: 'confirm',
                        str: field.properties["onClick"]["message"],
                        heading: field.properties["onClick"]["title"],
                        yesCbFn: 'successOnBothTrue',
                        noCbFn: 'successOnBothFalse',
                        field: JSON.stringify(field)
                    }
                    SirionUtils.openSirionDialogs(args);
                }

            } else {
                //                                console.log("no further action is defined on confirmation.");
            }
        } else if (angular.isDefined(field.properties["onClick"]["success"]) && (field.properties["onClick"]["success"].toString().trim().length > 0)) {
            const args = {
                popupType: 'confirm',
                str: field.properties["onClick"]["message"],
                heading: field.properties["onClick"]["title"],
                yesCbFn: 'cnfTrue',
                noCbFn: 'cnfFalse',
                field: JSON.stringify(field)
            }

            if (field?.api?.indexOf("/raiserequest") > -1) {
                args['yesCbFn'] = () => {
                    SirionUtils.redirectFromRaiseRequest();
                }
            }else if (this.openFromShareWithConuterParty) {
                this.dataOfnewExtarnalContract = null;
                let that = this;
                args['yesCbFn'] = () => {
                    that.cnfTrue(field);
                    const wfId = that.dataOfShareCountyPartyModal?.wfId;
                    const requestId = that.dataOfShareCountyPartyModal?.requestId;
                    that.callShareWithCounterParty(null,wfId,requestId,that.openFromShareWithConuterParty);
                }
            }else if(this.openFromUserRoleGroup){
                this.dataOfnewExtarnalContract = null;
                startLoader();
            }
            SirionUtils.openSirionDialogs(args);
        } else {
            field.openCommentDialogVar = {
                "temp": 'commentBox' + gFieldModel.replace(/\./g, "_"),
                "modal": commentForm
            }
            const args = {
                popupType: 'confirm',
                str: field.properties["onClick"]["message"],
                heading: field.properties["onClick"]["title"],
                yesCbFn: 'basicCnfTrue',
                noCbFn: 'basicCnfFalse',
                field: JSON.stringify(field)
            }
            SirionUtils.openSirionDialogs(args);
        }

        // if(this.pageType == "bulkAction"){
        //     var tableScope = $("#mainContainer").scope();
        //     tableScope.showBulkActionDialog.visible = false;
        // }

    }
    function directAjax(field){
        var self = this;
	    if (field.createEntityTypeId) {
	        //Create action buttons createEntityTypeId is for create Entity buttons from workflow list buttons.
	        formService.createContractCDRData(this, field);
            var allowCreate = true,
                apiUrl = field.api,
                hasSupplierFieldEditable = angular.element("[name=contractSupplier]").length > 0,
                boxTitle = (field && field.properties && field.properties.label) ? field.properties.label : field.label;
            // if(hasSupplierFieldEditable){
            //     //Global create form fields editable on CDR show page
            //     allowCreate = formService.validateRequiredFields(this, field);
            //     if(allowCreate){
            //         //Field values are filled correctly
            //         if( ! $.isEmptyObject(this.contractFromCDRData) ) {
            //             if(field.jspApi && field.jspApi.indexOf(":;")===-1){
            //                 apiUrl = formService.updateCDRcreateUrl(this, field);
            //             }else {
            //                 // Open create page directly (Skipping Global create form)
            //                 var fldVal = angular.copy(field);
            //                 this.createFreeFormUrl(field);
            //                 return;
            //             }
            //         }
            //         self.plusIconReq(apiUrl,field.label,undefined,undefined,field ,undefined);
            //     }
            // } else {
                if(self.pageType == "show" && ($rootScope.preSignature.cdrShowPage || self.cdrDetailedView) && field && field.createEntityTypeId && [4,5,9,10].indexOf(field.createEntityTypeId)>-1){
                    //Direct to Global Create Form pipeline
                    var fldVal = angular.copy(field);
                    self.loadFreeFormDialogBox(field,self.data);
                    return;
                }else {
                    //Open normal create page
                    self.plusIconReq(apiUrl, field.label, undefined, undefined, field, undefined);
                }
            // }
	    } else {
	        var jsonUrl = "/web/SPA-Angular/common/json/entityJsonTest.json";
	        var callMethod = "get";
	        var entity = "contractCreate";
	        this.createCloneOfScope();
	        if (field.api == "/tblcontracts/create" && field.requestType == 'GET') {
	            if (!self.multiSupplierApi && (!this.data.canSupplierBeParent && this.data.parentEntityType && (!this.data.parentEntityType.values || (this.data.parentEntityType.values && !this.data.parentEntityType.values.id)))) {
                    SirionUtils.openSirionDialogs({popupType: 'alert', str: this.data.popUpMessageForType, heading: intl_msg[24153]});
	                if (this.$root.$$phase != '$apply' && this.$root.$$phase != '$digest') {
	                    this.$apply();
	                }
	                return;
	            }
	
	            if (this.data.parentEntityType && this.data.parentEntityType.values && this.data.parentEntityType.values.id && this.data.parentEntityType.values.id != 1 && this.data.contracts && (!this.data.contracts.values || (this.data.contracts.values && !this.data.contracts.values.id))) {
                    SirionUtils.openSirionDialogs({popupType: 'alert', str: this.data.popUpMessageForTitle, heading: intl_msg[24153]});

                    if( _.get(this,"globalData.dynamicFormId") ){
                        window.sarc.channelBroadcast("reactDynamicForms",{
                            actionType:'toggleReqOnly',
                            bool: false
                        },`dfSubscriptions_${this.globalData.dynamicFormId}`)
                    }

	                if (this.$root.$$phase != '$apply' && this.$root.$$phase != '$digest') {
	                    this.$apply();
	                }
	                return;
	            }
	        }
	        var version = false;
            if(field.api) {
                entityFactory.entityNameMapper.forEach(function (d) {
                    if (d.version2 == true && field.api.indexOf(d.apiName + "/") > -1) {
                        version = true;
                    }
                });
            }
            if(this.data.sourceTitle && this.data.sourceTitle.values && !this.data.sourceTitle.values.id){
                this.data.sourceTitle.values = undefined;
            }

            if(field.api.indexOf('clone')>-1) {
                this.timeLineFeedScope = -1;
                this.commentDataScope =-1;
                this.expandLeftSection = true;
            }
            if(version && field.api && !field.api.includes("version=2.0")){
                field.api = SirionUtils.addQueryString(field.api,"version=2.0");
            }
            this.submitData(field.api, this.data, field.requestType, true);
	    }
    
    }

    function submitBulkActionData(field){
        if(this.showPagePermissionObj.showPageBulkAction){
            var sc1 = this;
            var dataObj=$rootScope.showPageBulkActionData.data.comment ? $rootScope.showPageBulkActionData.data.comment : {'comment':{}};
            fetchCommentFiles(dataObj);
            $rootScope.showPageBulkActionData.data.comment = angular.copy(dataObj);
            $rootScope.dataCopy = angular.copy($rootScope.showPageBulkActionData.data);
            $rootScope.dataCopy.actionUrl = field.api;
            sc1.removeOptions($rootScope.dataCopy, "$rootScope.dataCopy");
            showPageBulkActionService.performBulkAction.call(sc1,$rootScope.dataCopy);

        }
        else {
            var listScope = $("#mainContainer").scope();
            this.fetchCommentFiles();
            $rootScope.dataCopy = angular.copy(this.data);
            this.removeOptions($rootScope.dataCopy, "$rootScope.dataCopy");
            $rootScope.dataCopy.actionUrl = field.api;
            if ($rootScope.dataCopy?.comment?.comments?.values?.trim() === "") {
                // Validation Check if the comment field has redStar class (mandatory field) in bulk edit container
                var mandatoryCommentField = $(".bulkEditContainer")?.find(".coveringParent")?.find(".redStar");
                if (mandatoryCommentField.length > 0) {
                  Toaster.create(intl_msg[6410], {iconClass: "icon-Information_filled"});
                  return;
                }
              }
            listScope.commentPromise.resolve($rootScope.dataCopy);
            $rootScope.myModelInstance.close();
            this.bulkEntityId = [];
        }
    }


    function downloadClick(field) {
        window.location = appName + field.api;
    }

    function handleSubmitData(field,that,animateIcon,newShowPage){
        const hasReqIdInUrl = !!SirionUtils.getParameterValueFromURL(window.location.href,'requestId');
        if(field.nonWorkFlowAction && !hasReqIdInUrl){

            let wfId = field.api.substring(field.api.indexOf('work-') + 5)

            let payload = {
                entityId: _.get(that,'data.id.values'),
                entityTypeId:  _.get(that,'data.entityTypeId.values'),
                dataMap : {
                    body : {
                        data : that.data
                    }
                },
                taskId : wfId
            };
            $http.post('/workflow-action/save-payload',payload).then(res=>{
                if(_.get(res,'data.body.success') && _.get(res,'data.body.requestId') ){
                   // that[wfActionMapper(field.nonWorkFlowAction.id)](wfId,  _.get(res,'data.body.requestId'), field )
                    that[wfActionMapper(field.nonWorkFlowAction.id)](wfId,  _.get(res,'data.body.requestId'), field )
                }
            })
        } else{
            that.submitData(field.api, that.data, field.requestType, true, animateIcon, field,newShowPage);
        }
    }

    function submitData(field, newShowPage) {
        var animateIcon = false, thisElem = angular.element(this);
        if ($rootScope.bulkedit || (field.api && field.api.indexOf("/commentAttachments/bulkSave") > -1)) {
            animateIcon = true;
        }
        thisElem.attr("disabled", true); // prevent multiple requests to be triggered.
        setTimeout(function () {
            thisElem.removeAttr("disabled");
        }, 2000);
        var that = this;

        if (field.requestType !== "Print") {
            if (field.message != null && field.message != "null" && field.message != undefined && field.message != "") {
                if (field.confirmation) {
                    const args = {
                        popupType: 'confirm',
                        str: field.message,
                        heading: intl_msg[25772],
                        yesCbFn: 'confirmCnfTrue',
                        noCbFn: 'confirmCnfFalse',
                        field: JSON.stringify(field),
                        yesName: intl_msg[24184],
                        noName: intl_msg[23731]
                    }
                    SirionUtils.openSirionDialogs(args);
                } else {
                    const args = {
                        popupType: 'alert',
                        str: field.message,
                        heading: "MESSAGE",
                        yesCbFn: 'cancel',
                        yesName: intl_msg[24184],
                        closeCallBack: function () {
                            handleSubmitData(field,that,animateIcon)
                        }
                    }
                    SirionUtils.openSirionDialogs(args);
                }

            } else {
                var sc1 = this;
                if (sc1.bulkedit) {
                    var ret = formService.referencesValidation(sc1);
                    if (ret) {
                        handleSubmitData(field,that,animateIcon,newShowPage)
                    }
                }
                else if(field.properties && field.properties.replaceLinkUrl && sc1.rawDataCommentBox){
                    var dataObj=sc1.data.comment ? sc1.data.comment : {'comment':{}};
                    fetchCommentFiles(dataObj);
                    $rootScope.showPageBulkActionData["rawData"]["dataToPost"]["comment"]  = angular.copy(dataObj);
                    this.removeOptions($rootScope.showPageBulkActionData.rawData.dataToPost, "$rootScope.showPageBulkActionData.rawData.dataToPost");
                    var dataPromise = showPageBulkActionService.performRawDataBulkAction.call(this,field, $rootScope.showPageBulkActionData["rawData"]["dataToPost"],true);
                    dataPromise.success(function(data){
                        showPageBulkActionService.handleBulkActionForRawData.call(this,data);
                        sc1.$broadcast('updateComment', true);
                    });

                    //  $scope.submitData(field.api, $rootScope.showPageBulkActionData.data, field.requestType, true, animateIcon, field);
                }
                else if(sc1.showlineItemCommentBox){
                    if($rootScope.showPagePermissionObj.showPageBulkAction){
                        var dataObj=$rootScope.showPageBulkActionData.data.comment ? $rootScope.showPageBulkActionData.data.comment : {'comment':{}};
                            fetchCommentFiles(dataObj);
                            $rootScope.showPageBulkActionData.data.comment = angular.copy(dataObj);
                            $rootScope.dataCopy = angular.copy($rootScope.showPageBulkActionData.data);
                            $rootScope.dataCopy.actionUrl = field.api;
                            sc1.removeOptions($rootScope.dataCopy, "$rootScope.dataCopy");
                            showPageBulkActionService.performBulkAction.call(sc1,$rootScope.dataCopy);
                        }
                        else{
                            sc1.fetchCommentFiles();
                            $rootScope.dataCopy = angular.copy(sc1.data);
                            $scope.removeOptions($rootScope.dataCopy, "$rootScope.dataCopy");
                            $rootScope.dataCopy.actionUrl = field.api;
                            sc1.commentPromise.resolve($rootScope.dataCopy);
                            $("#showdialog_list").removeClass("commentBox");
                            $("#showdialog_list").dialog("close");
                            $scope.bulkEntityId = [];
                        }
                } else {
                    let data=this.data
                    if(this.bulkNovationData.length){
                        data=this.bulkNovationData
                    }
                    handleSubmitData(field,that,animateIcon,newShowPage)

                    //this.submitData(field.api, data, field.requestType, true, animateIcon, field,newShowPage);
                }
            }
        } else {
            $("#print_showPage").trigger("click");
        }
    }

    function refreshTable(field){
        $('.ng-scope').closest('.tab-content').addClass('importantRule');
        var tableScope = $("table[name=" + field.properties.onClick.tableName + "]").last().scope();
        $dataManipulationService.handleDummyModels(this.data, this.data.dummyModels, this);
        $dataManipulationService.handleSLMetValues(this);
        $rootScope.modiFiedData = angular.copy(this.data);
        if($rootScope.modiFiedData.relations.values && !Array.isArray($rootScope.modiFiedData.relations.values)) {
            $rootScope.modiFiedData.relations.values = [$rootScope.modiFiedData.relations.values];
        }
        //                    	  if($rootScope.modiFiedData && $rootScope.modiFiedData.slMet && $rootScope.modiFiedData.slMet.values != null && $rootScope.modiFiedData.slMet.values != undefined && typeof $rootScope.modiFiedData.slMet.values == "string"){
        //                    	    if($rootScope.modiFiedData.slMet.values == ""){
        //                    	      delete $rootScope.modiFiedData.slMet.values;
        //                    	    } else{
        //                    	      $rootScope.modiFiedData.slMet.values = {"id":$rootScope.modiFiedData.slMet.values};
        //                    	    }
        //                    	  }
        if ($rootScope.modiFiedData.dummyModels) {
            delete $rootScope.modiFiedData.dummyModels;
        }
        $dataManipulationService.removeFalseIds($rootScope.modiFiedData, $rootScope);
        this.removeOptions($rootScope.modiFiedData, "$rootScope.modiFiedData");
        var postingDatasend = angular.copy(this.searchedDataPost);
        $rootScope.$broadcast("downloadMetaDataEvent", postingDatasend);
        if (field.properties.onClick.tableName == 'downloadResults') {

            var postingData = angular.copy(this.searchedDataPost);
            if (postingData && postingData.body && postingData.body.data && postingData.body.data.clientCalendarType && postingData.body.data.clientCalendarType.values) {
                $.each(calendarTypes, function (index, val) {
                    if ($("select[name='clientCalendarType']").val() && val.id == $("select[name='clientCalendarType']").val()) {
                        postingData.body.data.clientCalendarType.values.id = val.id;
                        postingData.body.data.clientCalendarType.values.name = val.name;
                    }
                })
            }
            if (postingData.body.data.searchResults && postingData.body.data.searchResults.values) {
                delete postingData.body.data.searchResults.values;
            }
            var form = $('<form  action="' + appName + field.api + '" method="post" />');
            var input = $("<input type='hidden' name='jsonData' value='" + JSON.stringify(postingData) + "' />");
            form.append('<input type="hidden" name="' + csrf_param + '" value="' + token + '" />');
            form.append(input);
            $("body").append(form);
            form.submit();
            form.remove();
            $rootScope.$broadcast("downloadMetaDataEvent", postingData);
        } else {

            if ($rootScope.modiFiedData && $rootScope.modiFiedData.clauseText && $rootScope.modiFiedData.clauseText.values) {
                var tempVal = $rootScope.modiFiedData.clauseText.values;
                $rootScope.modiFiedData.clauseText.values = {};
                $rootScope.modiFiedData.clauseText.values.text = tempVal;
            }

            tableScope.filterPostOverride = {
                "body": {
                    "data": $rootScope.modiFiedData
                }
            };
            tableScope.responseBodyStructure = true;
            tableScope.tableName = field.properties.onClick.tableName;

            if (!this.loaderShown) {
                tableScope.loaderShown = true;
            }
            if(tableScope.tableName == "searchResults"  && $dataManipulationService.checkNullValueMetadataSearch(this)) {
                stopLoader();
                tableScope.loaderShown = false;
                if (field.api.indexOf("/metadatasearch/")>-1){
                    $rootScope.showSearchAdditinalError = true;
                    Toaster.create(intl_msg[26807]);

                } else
                    SirionUtils.openSirionDialogs({popupType: 'alert', str: intl_msg[26807], heading: intl_msg[24153]});

                return false;
            }

            if(tableScope.deferredInstance) {
                tableScope.deferredInstance.resolve("Initiated");
                tableScope.deferredInstance.promise.then(function () {
                    if (!tableScope.dataTable && tableScope.deferred && tableScope.deferred.promise) {
                        tableScope.deferred.promise.then(function () {
                            tableScope.$broadcast("initializeTable");
                        });
                    }else if(tableScope.dataTable){
                        tableScope.$broadcast("refreshData");
                    }
                });
            }

            /*if (tableScope.dataTable) {
                tableScope.$broadcast("refreshData");
            } else {
                tableScope.$broadcast("initializeTable");
            }*/
            //$rootScope.$broadcast("initializeTable");
            this.searchedDataPost = tableScope.filterPostOverride;
        }
    }

    function submitDelegationData(field){
        var animateIcon = false;
        var delegationSelectedObject;
        var delegationSelected = [];
        var a;
        angular.forEach(delegationService.selectedCheckBoxes, function(value) {
            if(value.indexOf(":;") > -1){
                 a= value.split(":;");
            }else {
                 a= value.split(",");
            }
            delegationSelectedObject = {
                "entityTypeId": parseInt(a[0]),
                "entityId":  parseInt(a[1]),
                "roleGroupId":  parseInt(a[2]),
                "flowDown": JSON.parse(a[3])
            }
            delegationSelected.push(delegationSelectedObject);
        });
        this.data.delegationRequests = delegationSelected
        this.submitData(field.api, this.data, field.requestType, true, animateIcon, field,true);
    }

    function ajaxSpecificData($scope,field){
        var valueField = "values";
        var fieldProps = field.properties["onClick"];
        if (angular.isUndefined(fieldProps) && angular.isUndefined(fieldProps["models"]) && angular.isUndefined(fieldProps["destination"])) {
            return
        }
        var destinationPropName = fieldProps["destination"];
        var destination = $showPageService.getGFieldModel(destinationPropName, "", "", "data");
        $scope.checkModel($scope.data, destination, "object");
        destination = $showPageService.getModelfromString.call($scope, destination);
        /*if(destination === null){break;}
        if(angular.isUndefined(destination[valueField])){break;}*/
        var fieldsToSendArray = fieldProps["models"].split(",");
        var objectToSend = {};
        var toDelete = [];
        if (angular.isDefined(fieldProps["delete"])) {
            toDelete = fieldProps["delete"].split(",");
            for (var i = 0; i < toDelete.length; i++) {
                toDelete[i] = toDelete[i].trim();
            }
        }
        var resetValuesOf = [];
        for (var i = 0; i < fieldsToSendArray.length; i++) {
            fieldsToSendArray[i] = fieldsToSendArray[i].trim();
            var modelToSend = $showPageService.getGFieldModel(fieldsToSendArray[i], "", "", "data");
            modelToSend = $showPageService.getModelfromString.call($scope, modelToSend);
            if (modelToSend === null) {
                // console.log("error in fetching field", fieldsToSendArray[i]);
                continue;
            }
            var modelToSendValue = modelToSend[valueField];
            if (angular.isUndefined(modelToSendValue)) {
                //  console.log("error in fetching field", fieldsToSendArray[i]);
                continue;
            }
            var lbl = fieldsToSendArray[i];
            if (angular.isDefined(fieldProps["mappings"]) && angular.isDefined(fieldProps["mappings"][lbl])) {
                lbl = fieldProps["mappings"][lbl];
            }
            objectToSend[lbl] = {
                "values": angular.copy(modelToSendValue)
            };
            if (toDelete.indexOf(fieldsToSendArray[i]) !== -1) {
                resetValuesOf.push(modelToSend);
            }
        }
        field.validations.forEach(function (d) {
            if (d.type == "rateCardOverlapping") {
                //todo impact areas to be checked
                var selectedFromDate = moment.tz(objectToSend.rateCardFromDate.values, SirionUtils.getDBDateFormat(), "UTC").unix();
                var selectedToDate = moment.tz(objectToSend.rateCardToDate.values, SirionUtils.getDBDateFormat(), "UTC").unix();
                var lowerBoundDate;
                var upperBoundDate;
                $scope.data.existingRateCards.values.forEach(function (rateCard, ind) {
                    var minDate = moment.tz(rateCard.rateCardFromDate, SirionUtils.getActualDateFormat(), "UTC").unix();
                    var maxDate = moment.tz(rateCard.rateCardToDate, SirionUtils.getActualDateFormat(), "UTC").unix();
                    if (!lowerBoundDate) {
                        lowerBoundDate = minDate;
                    } else if (minDate < lowerBoundDate) {
                        lowerBoundDate = minDate;
                    }
                    if (!upperBoundDate) {
                        upperBoundDate = maxDate;
                    } else if (maxDate > upperBoundDate) {
                        upperBoundDate = maxDate;
                    }
                });
                $rootScope.requestRateCard = function () {
                    $rootScope.cancel();
                    var getData = entityFactory.getJson(fieldProps.api, fieldProps.requestType, "contractCreate", objectToSend);
                    getData.success(
                        function (data) {
                            if (angular.isDefined(data) && angular.isDefined(data.data) && data.data != null && angular.isDefined(data.data[destinationPropName]) && $scope.isNotEmpty(data.data[destinationPropName])) {
                                if (angular.isDefined(data.error) && data.error != null && data.error.length > 0 && angular.isDefined(data.error[0].message)) {
                                    const args = {
                                        popupType: 'alert',
                                        str: data.error[0].message,
                                        heading: intl_msg[24168],
                                        yesCbFn: "cancel",
                                        yesName: intl_msg[24184],
                                    }
                                    SirionUtils.openSirionDialogs(args);
                                } else {
                                    resetValuesOf.forEach(function (modelToSend) {
                                        modelToSend[valueField] = undefined;
                                    })
                                    destination[valueField] = data.data[destinationPropName];
                                    if (!$scope.$$phase) {
                                        $scope.$apply();
                                    }
                                    if($scope.errors && $scope.errors.fieldErrors){
                                        $scope.errors.fieldErrors = null;
                                    }
                                }
                            } else {
                                const args = {
                                    popupType: 'alert',
                                    heading: intl_msg[24168],
                                    yesCbFn: "cancel",
                                    yesName: intl_msg[24184],
                                }
                                if (angular.isDefined(data.error) && data.error.length > 0 && angular.isDefined(data.error[0].message)) {
                                    var message = data.error[0].message;
                                    for (var i = 1; i < data.error.length; i++) {
                                        message += ", " + data.error[i].message;
                                    }
                                    args.str = message;
                                } else {
                                    args.str = intl_msg[6566];
                                }
                                SirionUtils.openSirionDialogs(args);
                            }
                            stopLoader();
                        }
                    );
                    getData.error(
                        function (data) {
                            const args = {
                                popupType: 'alert',
                                str: intl_msg[6566],
                                heading: intl_msg[24168],
                                yesCbFn: "cancel",
                                yesName: intl_msg[24184]
                            }
                            SirionUtils.openSirionDialogs(args);
                            stopLoader();
                        }
                    );
                }
                if ((selectedFromDate > lowerBoundDate && selectedFromDate < upperBoundDate) || (selectedToDate < upperBoundDate && selectedToDate > lowerBoundDate) || (selectedFromDate < lowerBoundDate && selectedToDate > upperBoundDate)) {
                    var messageInfo = d.message?d.message:intl_msg[d.messageLabelId];
                    const args = {
                        popupType: 'confirm',
                        str: messageInfo,
                        heading: intl_msg[25772],
                        yesCbFn: "requestRateCard",
                        noCbFn: "cancel",
                        yesName: intl_msg[24184],
                        noName: intl_msg[23731]
                    }
                    SirionUtils.openSirionDialogs(args);
                    } else {
                    $scope.requestRateCard();
                }
            }
        });
    }

    const wfActionMapper = function(action){
        let mapper = {
            1 :   'loadClauseAssembly',
            2 :   'templateWizard',
            3 :   'shareWithCounterParty',
            4 :   'sendForSignature'
        }
        return mapper[action]
    }

    return {
        deleteConfirmation: deleteConfirmation,
        directNonAjax: directNonAjax,
        downloadClick: downloadClick,
        submitData: submitData,
        directAjax:directAjax,
        basicConfirmation:basicConfirmation,
        refreshTable:refreshTable,
        submitBulkActionData:submitBulkActionData,
        submitDelegationData:submitDelegationData,
        ajaxSpecificData:ajaxSpecificData,
        handleSubmitData:handleSubmitData
    }
    }]);
})();
